<script>
	import { cn } from "./cn.js";
	// shadcn 스타일 셀렉트: 접근성 좋은 네이티브 <select>를 토큰으로 스타일 + chevron 오버레이.
	// 사용: <Select bind:value={x} on:change={...}><option .../></Select>
	export let value = undefined;
	// 검증 실패 표시(예: 필수 선택인데 비어 있음) — 테두리·포커스 링을 destructive로.
	export let invalid = false;
	let className = "";
	export { className as class };

	// 호출부가 폭 클래스를 주면 기본 tw-w-full을 빼서 서로 싸우지 않게 한다.
	// cn은 tailwind-merge가 아니라 단순 결합이라 두 클래스가 함께 남고, 그러면 스타일시트에서
	// 뒤에 오는 tw-w-full이 항상 이겨 호출부의 폭 지정이 무시된다.
	$: callerSetsWidth = /(?:^|\s)tw-(?:w|min-w|max-w)-/.test(className);
</script>

<div class={cn("tw-relative tw-inline-flex tw-font-sans", !callerSetsWidth && "tw-w-full", className)}>
	<select
		bind:value
		class={cn(
			"tw-h-10 tw-w-full tw-cursor-pointer tw-appearance-none tw-rounded-md tw-border tw-border-input tw-bg-background tw-py-2 tw-pl-3 tw-pr-9 tw-text-sm tw-text-foreground tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
			invalid && "tw-border-destructive focus-visible:tw-ring-destructive",
		)}
		on:change
		on:input
		on:focus
		on:blur
		{...$$restProps}
	>
		<slot />
	</select>
	<svg
		class="tw-pointer-events-none tw-absolute tw-right-2.5 tw-top-1/2 -tw-translate-y-1/2 tw-h-4 tw-w-4 tw-text-muted-foreground"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
	>
		<path d="m6 9 6 6 6-6" />
	</svg>
</div>
